module.exports = __webpack_public_path__ + "img/animals_cat1.6f0db77d.png";